module.exports = __webpack_public_path__ + "img/yuedu.2745f9a1.png";